<div class="main_box">
    <div class="">
        <div class="modal-header" style="background-color: #294058;">
             <h4 class="modal-title" style="margin: auto;color: white;">Device Info: &nbsp;{{deviceInfoData?.siteName || 'N/A'}}
             <span *ngIf="deviceInfoData?.solarState == true">
                <img src="../../../../assets/imgs/solar-panels.png" class="img">
             </span>
             </h4>
        </div>
        <div class="">
            <div class="grid-container">
                <div class="grid-item"><p class="device_info_heading">SITE NAME</p><p class="device_info">{{deviceInfoData?.siteName || 'N/A'}}</p></div>
                <div class="grid-item"><p class="device_info_heading">SITE TYPE</p><p class="device_info">{{deviceInfoData?.siteType || 'N/A'}}</p></div>
                <div class="grid-item"><p class="device_info_heading">POTENTIAL ID</p><p class="device_info">{{deviceInfoData?.potentialId || 'N/A'}} </p></div>  
                <div class="grid-item"><p class="device_info_heading">TYPE</p><p class="device_info">{{deviceInfoData?.type || 'N/A'}} </p></div>
                <div class="grid-item"><p class="device_info_heading">PORT</p><p class="device_info">{{deviceInfoData?.port || 'N/A'}} </p></div>

                <div class="grid-item"><p class="device_info_heading">LINE VOLTAGE STATE</p><p class="device_info">{{((deviceInfoData?.lineVoltage==1)?'ON':'OFF')}}</p></div>
                <div class="grid-item"><p class="device_info_heading">BATTERY VOLTAGE</p><p class="device_info">{{((deviceInfoData?.batteryVoltage)?(deviceInfoData?.batteryVoltage):'N/A')}}</p></div>
                <div class="grid-item"><p class="device_info_heading">ENCODER</p><p class="device_info">{{((deviceInfoData?.encoder==1)?'ON':'OFF')}}</p></div>  
                <div class="grid-item"><p class="device_info_heading">RELAY2</p><p class="device_info">{{((deviceInfoData?.realy2==1)?'ON':'OFF')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">SIREN</p><p class="device_info">{{((deviceInfoData?.siren==1)?'ON':'OFF')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">ROUTER</p><p class="device_info">{{((deviceInfoData?.router==1)?'ON':'OFF')}} </p></div>  
                <div class="grid-item"><p class="device_info_heading">TEMPERATURE(F)</p><p class="device_info">{{((deviceInfoData?.temperature)?(deviceInfoData?.temperature):'N/A')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">DEV DATE</p><p class="device_info">{{((deviceInfoData?.devDate)?(deviceInfoData?.devDate):'N/A')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">SOLAR STATE</p><p class="device_info">{{((deviceInfoData?.solarState)?(deviceInfoData?.solarState):'N/A')}}</p></div>  
                <div class="grid-item"><p class="device_info_heading">STATUS</p><p class="device_info">{{((deviceInfoData?.status)?(deviceInfoData?.status):'N/A')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">HARDWARE</p><p class="device_info">{{((deviceInfoData?.hardware)?(deviceInfoData?.hardware):'N/A')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">SERIAL NO</p><p class="device_info">{{((deviceInfoData?.serialNo)?(deviceInfoData?.serialNo):'N/A')}}</p></div>
                <div class="grid-item"><p class="device_info_heading">VERSION</p><p class="device_info">{{((deviceInfoData?.version)?(deviceInfoData?.version):'N/A')}} </p></div>  
                <div class="grid-item"><p class="device_info_heading">IP ADDRESS</p><p class="device_info">{{((deviceInfoData?.ip)?(deviceInfoData?.ip):'N/A')}} </p></div>
                <div class="grid-item"><p class="device_info_heading">Site Time Zone</p><p class="device_info">{{(deviceInfoData?.timeZone)?(deviceInfoData?.timeZone):'N/A'}} </p></div>
                <div class="grid-item"><p class="device_info_heading">Monitoring Service</p><p class="device_info">{{(deviceInfoData?.monitoringService)?(deviceInfoData?.monitoringService):'N/A'}} </p></div>
              </div>
              <div class="grid-container1">
                <div class="grid-item1"><p class="device_info_heading">REASON</p><p class="device_info">{{(deviceInfoData?.reason)?(deviceInfoData?.reason):'N/A'}} </p></div>             
                
              


              </div>
              <div class="grid-container1">
                <div class="grid-item1">
                    <p class="device_info bold_font" >Holidays/Exceptional days </p>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex">
                        <div class="bold_font">Date :</div>
                        <div class="bold_font">Uptime Start:</div>
                        <div class="bold_font">Uptime End:</div>
                    </div>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex" *ngIf="deviceInfoData?.solarInfo == null">
                        <span><strong>N/A</strong></span>
                        <div>
                             <p>
                                <span style="display:inline-flex"> N//A</span>
                                <br>
                                <span style="display:inline-flex">N/A</span>
                            </p>
                        </div>
                    </div>
                    <div class="device_info row col-md-1 col-sm-2" style="display:inline-flex" *ngFor="let datetime of deviceInfoData?.solarInfo?.exceptionDays">
                        <span><strong>{{(datetime.date)?(datetime.date):'N/A'}}</strong></span>
                        <div>
                             <p *ngFor="let uptime of datetime?.times">
                                <span style="display:inline-flex"> {{(uptime.uptimeStart)?(uptime.uptimeStart):'N/A'}}</span>
                                <br>
                                <span style="display:inline-flex">{{uptime.uptimeEnd?(uptime.uptimeEnd):'N/A'}}</span>
                            </p>
                        </div>
                    </div>
                </div>
              </div>
              <div class="grid-container1">
                <div class="grid-item1">
                    <p class="device_info bold_font" >Solar script times </p>
                    <div class="device_info bold_font row col-md-1 col-sm-3" style="display:inline-flex">
                       Check Days: {{((deviceInfoData?.solarInfo?.checkDays)?(deviceInfoData?.solarInfo?.checkDays):'N/A')}}
                     </div>
                    <div class="device_info row bold_font col-md-1 col-sm-3" style="display:inline-flex">
                       Start time: {{((deviceInfoData?.solarInfo?.downtimeStart)?(deviceInfoData?.solarInfo?.downtimeStart):'N/A')}}
                    </div>
                    <div class="device_info row bold_font col-md-1 col-sm-3" style="display:inline-flex">
                        End time: {{((deviceInfoData?.solarInfo?.downtimeEnd)?(deviceInfoData?.solarInfo?.downtimeEnd):'N/A')}}
                     </div>
                </div>
              </div>
        </div>
    </div>
</div>

